let counter = 0;

export function getUniqueId() {
  return counter++;
}
